import React from 'react'
import { BsFillTelephoneFill } from 'react-icons/bs'
import { FiMail } from 'react-icons/fi'
import { FaAddressCard } from 'react-icons/fa'

const ContactUsLeft = () => {
    return (
        <>
            <div className="contact-us w-[90%] md:w-[50%]">
                <div>
                    <h3 className='text-[1.8em] md:text-[2.3em] font-bold mb-[20px]'>Contact Us</h3>
                </div>

                <div className="innergrid flex mb-5 md:flex-row ">
                    <span className="iconbox w-11 h-11 inline-block bg-[#BE9FE1] text-center p-[11px] rounded-lg">
                        <BsFillTelephoneFill className='before:content-[""] text-xl text-white' />
                    </span>
                    <div className='ml-[-35px]'>
                        <span className='lbl inline-block md:block pl-[55px] text-base text-[#000000]'>
                            Phone
                        </span>
                        <a href='tel:1234567890' className='max-lg:text-xs m-0 pl-[55px] font-bold text-black'>+91-9111111111</a>
                    </div>
                </div>

                <div className="innergrid  mb-5 flex">
                    <span className="iconbox w-11 h-11 inline-block bg-[#BE9FE1] text-[#fff] text-center p-[11px] rounded-lg">
                        <FiMail className='before:content-[""] text-xl text-white' />
                    </span>
                    <div className='ml-[-35px]'>
                        <span className='lbl block pl-[55px] text-base text-[#000000]'>
                            Email
                        </span>
                        <h5 className='m-0 max-lg:text-xs pl-[55px] sm:font-bold text-black'>gurujipublishinghouse@gmail.com</h5>
                    </div>
                </div>


                <div className="innergrid flex ">
                    <span className="iconbox w-11 h-11 inline-block bg-[#BE9FE1]  text-center p-[11px] rounded-lg">
                        <FaAddressCard className='before:content-[""] text-xl text-white' />
                    </span>
                    <div className='ml-[-35px]'>
                        <span className='lbl block pl-[55px] text-base text-[#000000]'>
                            Address
                        </span>

                        <h5 className='m-0 pl-[55px] font-bold text-black'>New Delhi - 110023</h5>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUsLeft